<template>
  <div>
    <div class="custom-card">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="picture-upload-form text-center">
              <div class="my-3">
                <image-uploader :imageUrl="organization.orgimage" @uploaded="onImageUploaded"
                  @remove-image="removeImage" :isUploadingImage="isUploadingImage" />
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="fname" class="label">Organization Name</label>
                <input type="text" class="input" v-model="organization.companyname"
                  placeholder="-- Enter First Name --" />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="mname" class="label">Organization Type</label>
                <el-select filterable v-model="organization.type" placeholder="Select">
                  <el-option v-for="type in organizationTypes" :key="type" :label="type" :value="type">
                  </el-option>
                </el-select>
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="lastname" class="label">Specialization</label>
                <el-select filterable v-model="organization.specialization" placeholder="Select"
                  :disabled="!filteredSpecializations.length">
                  <el-option v-for="specialization in filteredSpecializations" :key="specialization"
                    :label="specialization" :value="specialization">
                  </el-option>
                </el-select>
              </div>
              <div hidden class="new-user-form__single-input-wrapper">
                <label for="number" class="label">Specialization</label>
                <input type="email" v-model="organization.customdomain" class="input" disabled />
              </div>
            </div>
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="gender" class="label">Business Coverage</label>
                <el-select filterable v-model="organization.industry" placeholder="Select"
                  @change="removeSelectedSpecialization">
                  <el-option v-for="industry in industries" :key="industry" :label="industry" :value="industry">
                  </el-option>
                </el-select>
              </div>

              <div hidden class="new-user-form__single-input-wrapper">
                <label for="lastname" class="label">Specializations</label>
                <el-select filterable v-model="organization.specialization" placeholder="Select"
                  :disabled="!filteredSpecializations.length">
                  <el-option v-for="specialization in filteredSpecializations" :key="specialization"
                    :label="specialization" :value="specialization">
                  </el-option>
                </el-select>
              </div>

              <div class="new-user-form__single-input-wrapper">
                <label for="email" class="label">Domain Name</label>
                <div class="domain-cover flex">
                  <input type="text" placeholder="https://muleEX.com/" class="input muleEX" disabled />
                  <!-- <div>https://muleEX.com/</div> -->
                  <input type="text" v-model="organization.companyname" class="input" placeholder="-- Enter --"
                    disabled />
                </div>

              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="email" class="label">Email Address</label>
                <input type="email" disabled class="input" v-model="organization.email" />
              </div>
            </div>
            <div class="input-row">

              <div class="new-user-form__single-input-wrapper">
                <label for="number" class="label">Phone Number</label>
                <vue-tel-input :preferredCountries="['Nigeria']" v-model="organization.mobile_no"></vue-tel-input>
              </div>
              <div class="new-user-form__single-input-wrapper"></div>
              <div class="new-user-form__single-input-wrapper"></div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <h3>Contact Adddress</h3>
          </div>

          <div class="col-md-12 col-lg-12 col-12">
            <div class="input-row mt-4">
              <div class="new-user-form__single-input-wrapper">
                <label for="fname" class="label">Address</label>
                <input type="text" class="input" v-model="location.address" placeholder="-- Enter address --" />

              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="mname" class="label">Country</label>
                <el-select v-model="selectedCountry" value-key="isoCode" placeholder="-- Select Country --">
                  <el-option v-for="country in countries" :key="country.isoCode" :label="country.name" :value="country">
                  </el-option>
                </el-select>
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="gender" class="label">State</label>
                <el-select v-model="selectedState" value-key="isoCode" placeholder="-- Select State --">
                  <el-option v-for="state in states" :key="state.isoCode" :label="state.name" :value="state">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="lname" class="label">City</label>
                <el-select v-model="selectedCity" placeholder="-- Select City --">
                  <el-option v-for="city in cities" :key="city.name" :label="city.name" :value="city.name">
                  </el-option>
                </el-select>
              </div>

              <div hidden class="new-user-form__single-input-wrapper">
                <label for="email" class="label">Timezone</label>
                <el-select v-model="organization.orgTimezone" placeholder="Select" filterable>
                  <el-option v-for="timezone in timezones" :key="timezone" :label="timezone" :value="timezone">
                  </el-option>
                </el-select>
              </div>

              <div hidden class="new-user-form__single-input-wrapper">
                <label for="number" class="label">Language</label>
                <el-select v-model="organization.language" placeholder="Select">
                  <el-option v-for="language in languages" :key="language" :label="language" :value="language">
                  </el-option>
                </el-select>
              </div>
              <div class="new-user-form__single-input-wrapper"></div>
              <div class="new-user-form__single-input-wrapper"></div>

            </div>
          </div>

        </div>
      </div>

      <div class="flex items-center my-4 justify-between">
        <div class="cursor-pointer" @click="$router.go(-1)">
          <p>Cancel</p>
        </div>
        <base-button text="Save" @click="updateOrganization" :loading="updatingOrganization" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  organizationTypes,
  industries,
  specializations,
} from "@/utilities/globalVariables";
import ImageUploader from "@/components/3pl/Users/ImageUploader";
import timezones from "@/utilities/timezones";

import { Country, State, City } from "country-state-city";

export default {
  components: {
    ImageUploader,

  },
  data() {
    return {
      isUploadingImage: false,
      updatingOrganization: false,
      selected: null,
      options: ["Option 1", "Option 2", "Option 3"],
      organizationTypes: organizationTypes,
      industries: industries,
      specializations: specializations,
      location: {
        locationName: "",
        type: "",
        address: "",
        country: "",
        state: "",
        city: "",
      },
      organization: {
        id: "",
        companyname: "",
        type: "",
        country: "",
        stateId: "",
        city: "",
        industry: "",
        specialization: "",
        mobile_no: "",
        image: null,
        orgimage: "",
        customdomain: "",
        regnumber: "",
        email: "",
        web: "",
        facebook: "",
        instagram: "",
        linkedin: "",
        twitter: "",
        language: "",
        orgTimezone: "",
      },
      states: [],
      selectedIndustry: "",
      cities: [],
      countries: [],
      selectedCountry: null,
      selectedState: null,
      selectedCity: null,
      timezones: timezones,
      languages: ["English"],
      user: {},
      orgLocation: {},
    };
  },
  computed: {
    filteredSpecializations() {
      let indexOfSelectedIndustry = this.industries.indexOf(
        this.organization.industry
      );
      if (indexOfSelectedIndustry >= 0) {
        return this.specializations[indexOfSelectedIndustry];
      } else {
        return [];
      }
    },

  },
  mounted() {
    this.countries = Country.getAllCountries();
    this.findUserDetails();

    this.user = JSON.parse(localStorage.getItem("loggedInUser"));

    const organization = JSON.parse(
      localStorage.getItem("organizationDetails")
    );

    this.selectedIndustry = this.organization.industry;
    this.organization.id = organization.id;
    this.organization.companyname = organization.companyname;
    this.organization.type = organization.type;
    this.organization.customdomain = organization.customdomain;
    this.organization.regnumber = organization.regnumber;
    this.organization.address = organization.address;
    this.organization.country = organization.country;
    this.organization.stateId = organization.stateId;
    this.organization.city = organization.city;
    this.organization.email = organization.email;
    this.organization.industry = organization.industry;
    this.organization.specialization = organization.specialization;
    this.organization.mobile_no = organization.mobile_no;
    this.organization.orgimage = organization.orgimage;
    this.organization.web = organization.web;
    this.organization.facebook = organization.facebook;
    this.organization.instagram = organization.instagram;
    this.organization.linkedin = organization.linkedin;
    this.organization.twitter = organization.twitter;
    (this.organization.language = organization.language),
      (this.organization.orgTimezone = organization.orgTimezone);
  },
  watch: {
    selectedCountry(newVal) {
      if (!newVal) {
        this.states = []
        this.cities = []
        return
      }

      this.states = State.getStatesOfCountry(newVal.isoCode)
      this.location.country = newVal.name
    },


    selectedState(newVal) {
      if (!newVal) {
        this.cities = []
        this.selectedCity = null
        return
      }
      this.cities = City.getCitiesOfState(
        this.selectedCountry.isoCode,
        newVal.isoCode
      )
      // Save actual name
      this.location.state = newVal.name
    },
    selectedCity(newVal) {
      if (!newVal) return
      this.location.city = newVal
    },

  },
  methods: {

    async updateOrganization() {
      this.updatingOrganization = true;
      this.organization.orgId = localStorage.getItem("organizationId");

      let payload = {
        org: {
          id: this.organization.id,
          companyname: this.organization.companyname,
          regnumber: this.organization.regnumber,
          web: this.organization.web,
          industry: this.organization.industry,
          specialization: this.organization.specialization,
          facebook: this.organization.facebook,
          linkedin: this.organization.linkedin,
          twitter: this.organization.twitter,
          instagram: this.organization.instagram,
          type: this.organization.type,
          language: this.organization.language,
          orgTimezone: this.organization.orgTimezone,
          mobile_no: this.organization.mobile_no,
          orgimage: this.organization.orgimage, // ✅ INCLUDED
        },
        location: this.location,
      };

      try {
        let response = await this.$_updateOrganizationInformation(payload);

        localStorage.removeItem("organizationDetails");
        localStorage.setItem(
          "organizationDetails",
          JSON.stringify(response.data.data.org)
        );
        this.generateToast(
          "Organization Details successfully updated!",
          "success"
        );
        this.updatingOrganization = false;
        this.$router.push({ name: "AccountProfile" });
      } catch (error) {
        this.handleError(error);
        this.updatingOrganization = false;
      }
    },


    async findUserDetails() {
      try {
        let response = await this.$_findUserDetails();
        this.location = response.data.data.Org.locations[0];
        // ✅ STEP 1: Set selectedCountry properly (OBJECT, not string)
      this.selectedCountry = this.countries.find(
        c => c.name === this.location.country
      );

      // ✅ STEP 2: Load states immediately
      if (this.selectedCountry) {
        this.states = State.getStatesOfCountry(this.selectedCountry.isoCode);

        // ✅ STEP 3: Set selectedState properly
        this.selectedState = this.states.find(
          s => s.name === this.location.state
        );
      }
      // ✅ STEP 4: Load cities immediately
      if (this.selectedCountry && this.selectedState) {
        this.cities = City.getCitiesOfState(
          this.selectedCountry.isoCode,
          this.selectedState.isoCode
        );

        // ✅ STEP 5: Set selectedCity
        this.selectedCity = this.location.city;
      }
        // this.selectedCity = this.location.city
        // this.selectedCountry = this.location.country
        // this.selectedState = this.location.state
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    onImageUploaded(url) {
      this.uploadImage(url);

    },
    async uploadImage(image) {
      this.isUploadingImage = true;

      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", "zunt8yrw");

      try {
        const response = await this.$_uploadImage(formData);
        const imageUrl = response?.data?.fileUrl;

        if (!imageUrl) throw new Error("Upload failed: no URL returned");

        this.organization.orgimage = imageUrl;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isUploadingImage = false;
      }
    },

    removeSelectedSpecialization() {
      this.organization.specialization = "";
    },
    removeImage() {
      this.organization.orgimage = null;
    },
    returnPayload() {
      return this.organization;
    },
  },
};
</script>

<style lang="scss" scoped>
.muleEX::placeholder {
  font-size: 12px;
  font-weight: 400;
  color: rgba(245, 244, 250, 1);
}

.muleEX {
  background-color: rgba(56, 63, 81, 1);
}

.domain-cover {
  gap: 1%;
}

.picture-upload-form {
  border-radius: 10px;
  padding: 1.55rem 1rem;
}

.picture-upload-form__img-wrapper {
  position: relative;
}

.user-img {
  width: 10rem;
  margin: 1.5rem auto;
}

.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}

.picture-upload-form__meta {
  padding-top: 1rem;
}

.label {
  font-size: 0.9rem;
}

.input {
  margin-bottom: 0.5rem;
}

.new-user-form__col-three {
  padding-top: 1.25rem;
}

hr {
  margin: 2rem 0;
}

.input-row {
  width: 100%;
  display: flex;
}

.input-row>div {
  width: 100%;
  padding-right: 1rem;
}

.modal-input {
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  height: 2.75rem;
  border-radius: 4px;
  display: flex;

  input {
    border: none;
    background: transparent;
  }

  span {
    align-self: center;
    padding: 0 0.5rem;
    color: #747474;
    cursor: pointer;
  }
}

@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }

  .input-row div {
    width: 100%;
  }
}
</style>
